var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "check_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#check_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.367 11.517a.615.615 0 0 1-.225-.042.54.54 0 0 1-.192-.125L3.167 8.567a.463.463 0 0 1-.142-.359.557.557 0 0 1 .142-.358c.1-.1.22-.15.358-.15.14 0 .253.05.342.15l2.5 2.5 5.766-5.766c.09-.1.206-.15.35-.15.145 0 .262.05.35.15.1.1.15.219.15.358a.49.49 0 0 1-.15.358l-6.05 6.05a.542.542 0 0 1-.19.125.62.62 0 0 1-.226.042Z",
    fill: "#19CA80"
  }))));
};

export default SvgCheck;